/**
 * Router path for a charity's public profile (by numeric id).
 * Probably will update this to a slug
 */
export function charityPublicProfilePath(charityOrId) {
  const id =
    charityOrId != null && typeof charityOrId === 'object'
      ? charityOrId.id
      : charityOrId
  if (id == null || String(id).trim() === '') return null
  return `/profile/charity/${encodeURIComponent(String(id))}`
}

export function charityAccountPath(charityOrId) {
  const id =
    charityOrId != null && typeof charityOrId === 'object'
      ? charityOrId.id
      : charityOrId
  if (id == null || String(id).trim() === '') return null
  return `/charity-account/${encodeURIComponent(String(id))}`
}

/**
 * Registrations the signed-in user can open for dashboard, account, and Stripe.
 * CivicRush staff "Verified" is not required; Stripe verification is separate.
 * The registrations index already omits Unverified.
 */
export function userManagedCharityRegistrations(registrations) {
  return (registrations || []).filter(reg => reg?.charity?.id != null)
}
